import { createAction } from '@reduxjs/toolkit';
import * as commonActions from './action-types';
import * as commonActionUtils from './_action-utilities';
const { UserSession } = commonActions;

const sessionTimeout = createAction<void>(UserSession.TIMEOUT);
const sessionRefresh = createAction<void>(UserSession.REFRESH);
const sessionReset = createAction<void>(UserSession.RESET);
const sessionActivityPrompt = createAction<void>(UserSession.ACTIVITY_PROMPT);

export { sessionRefresh, sessionReset, sessionTimeout, sessionActivityPrompt };
